export type ZipCodeVariant = "default" | "compact" | "inline" | "flat";

export const getVariantStyles = (variant: ZipCodeVariant) => {
  switch (variant) {
    case "compact":
      return "bg-gray-50 dark:bg-dark-800 border border-gray-200 dark:border-dark-700 rounded-lg p-2.5";
    case "inline":
      return "inline-flex items-center gap-1 text-sm text-gray-600 dark:text-dark-300";
    case "flat":
      return "border-b border-gray-200 dark:border-dark-700 pb-4";
    default:
      return "bg-white dark:bg-dark-800 border border-gray-200 dark:border-dark-700 rounded-xl p-3 sm:p-4";
  }
};

export const getTextStyles = (variant: ZipCodeVariant) => {
  switch (variant) {
    case "compact":
      return "text-xs font-medium text-gray-700 dark:text-dark-200";
    case "inline":
      return "text-sm text-gray-600 dark:text-dark-300";
    case "flat":
      return "text-sm font-semibold text-gray-900 dark:text-white";
    default:
      return "text-sm font-medium text-gray-900 dark:text-white";
  }
};

export const getIconSize = (variant: ZipCodeVariant) => {
  switch (variant) {
    case "compact":
      return "h-3 w-3";
    case "inline":
      return "h-3 w-3";
    case "flat":
      return "h-4 w-4";
    default:
      return "h-3.5 w-3.5 sm:h-4 sm:w-4";
  }
};
